import { history } from 'umi'
import { message as $message } from 'antd'
import Qs from 'qs'
import pathRegexp from 'path-to-regexp'
import { getManager } from 'gyl-common/tools/tab'
import { jumpSiteDomFn } from '@/modules/dlz/helper'
import { goToNewlywedZone } from '@/modules/findCooper/utils/jumpNewlywedZone'
import getCoIdIsBigShopByCoId from '@/modules/user/features/getCoIdIsBigShopByCoId'
import { onSqGoChannel } from '@/modules/sqmall/helper'
import { sqTowerPageList, noInSqTowerPageList } from '@/modules/sqmall/constant'
import { getToken } from '@/utils/token'
import { getEnvPrefix } from '@/utils/env'
import { wrapResponseData } from '@/utils/wrapRequest'
import { openGetCompanySiteConfig } from '@/services/dlz'
import { getTicket } from '@/services/login'

import { getCurrentRoute } from './utils'

// 独立站路由
const GO_DLZ_ROUTES = [
    '/channel/my/businessDynamicsDetail/:id?',
    '/manage/goods/qualitySupplier/detail/:id?',
    '/findCooperation/detail/:id?'
]

// 检查是否是需要跳独立站的路由
const readDlzParamsId = location => {
    const { pathname, query } = location

    for (let i = 0; i < GO_DLZ_ROUTES.length; i++) {
        const item = GO_DLZ_ROUTES[i]
        const path = pathRegexp(item).exec(pathname)
        if (path && query?.type !== 'offline') {
            return path[1]
        }
    }

    return null
}

const PAGE_ENMUM = {
    newlywedZone: 'newlywedZone',
    dlz: 'dlz'
}

// 跳转到分销小站
export const loadPartnerShopConfig = async ({ location, dlzId }) => {
    const { search } = location || {}

    try {
        const { success, data, message } = await openGetCompanySiteConfig({
            supplierId: dlzId
        })
        if (success) {
            const { enabled, siteDomain, coId } = data || {}

            if (getCoIdIsBigShopByCoId(coId)) {
                // 爆款专区
                return {
                    page: PAGE_ENMUM.newlywedZone
                }
            }

            if (enabled && siteDomain) {
                const url = `${siteDomain.indexOf('http') !== -1 ? siteDomain : `//${siteDomain}`}/home${search}`

                // 品牌站
                return {
                    page: PAGE_ENMUM.dlz,
                    url
                }
            }
        } else {
            $message.error(message)
        }
    } catch (error) {
        console.error('catchError', error)
    }

    return {
        page: ''
    }
}

export const openPatnerShop = (config, defaultOpen, goToNewlywedZoneQuery) => {
    if (config.page === PAGE_ENMUM.newlywedZone) {
        goToNewlywedZone({
            _blank: true,
            ...(goToNewlywedZoneQuery || {})
        })
        return false
    }

    if (config.page === PAGE_ENMUM.dlz) {
        jumpSiteDomFn(config.url)
        return false
    }

    return defaultOpen()
}

// 寻合作路由
const PATH_NAME_List = [
    '/findCooperation/goods',
    '/partnership/findSupplierForPartner',
    '/findCooperation/list',
    '/findCooperation/distributorList',
    '/findCooperation/newlywedZone',
    '/channel/my/findCooperation',
    '/channel/my/partnership/findSupplierForPartner',
    '/channel/my/findCooperation/goods',
    '/channel/my/findCooperation/newlywedZone',
    // 找达人
    '/pages/daren/findDarenList',
    // help文档
    '/help'
]

// 检测路由是否匹配
const checkIsFindCoopPathname = location => {
    return PATH_NAME_List.includes(location.pathname)
}

/**
 * main：主站
 * sub：子站
 */
const ORIGIN_LIST = [
    {
        main: 'gyl.scm121.com',
        sub: 'gyl.ttdahuo.com'
    },
    {
        main: 'sc.scm121.com',
        sub: 'sc.ttdahuo.com'
    },
    {
        main: 'light.scm121.com',
        sub: 'light.ttdahuo.com'
    },
    {
        main: 'zh.scm121.com',
        sub: 'zh.ttdahuo.com'
    }
]

const findHost = ({ host }) => {
    return ORIGIN_LIST.find(v => host.includes(v.main) || host.includes(v.sub))
}

const checkShouldBlock = () => {
    const urlObj = new URL(window.location.href)

    const targe = findHost(urlObj)

    if (targe) {
        return true
    }

    return false
}

/**
 * 寻合作的几个页面拦截，拦截后打开对应的域名
 */
const blockFindCoop = (location, isFirstEnter) => {
    try {
        const urlObj = new URL(window.location.href)

        let targetHost = ''

        if (checkIsFindCoopPathname(location)) {
            targetHost = findHost(urlObj)?.sub
        } else {
            targetHost = findHost(urlObj)?.main
        }
        if (!targetHost) {
            return true
        }

        if (urlObj.host.includes(targetHost)) {
            return true
        }

        // 打开页面
        const openPage = async () => {
            const _gt = await wrapResponseData(getTicket)

            const newQuery = {
                ...(location.query || {})
            }

            if (_gt) {
                Object.assign(newQuery, {
                    _gt
                })
            } else {
                Object.assign(newQuery, {
                    token: getToken()
                })
            }

            const newLocation = {
                ...location,
                query: newQuery,
                search: Qs.stringify(newQuery, { addQueryPrefix: true })
            }

            const envPrefix = getEnvPrefix()

            const url = `${urlObj.protocol}//${envPrefix}${targetHost}${history.createHref(newLocation)}`

            if (isFirstEnter) {
                window.location.href = url
            } else {
                window.open(url, '_blank')
            }
        }

        // 独立站，分销小站需要判断是否开启了独立站，如果开启了独立站需要打开“品牌小站”，否则访问“分销小站”
        const dlzId = readDlzParamsId(location)
        if (dlzId) {
            loadPartnerShopConfig({
                location,
                dlzId
            }).then(e => {
                openPatnerShop(e, openPage)
            })
            return false
        }

        openPage()
        return false
    } catch (e) {
        console.error(e)
    }

    return true
}

const restoreTabHistoryLoaction = (location, action) => {
    const manager = getManager()

    if (manager) {
        // tab路由还原
        manager.blockHistory(location, action)
    }
}

const blockSpecialAppLocation = location => {
    // 独立站应用路由
    const isDlzApp = window.PROJECT_CONFIG.terminalNameSecond === PROJECT_CONFIG.dlzTerminalName

    if (isDlzApp) {
        const hasRoute = getCurrentRoute({
            router: window.PROJECT_CONFIG.routes,
            pathname: location?.pathname
        })

        if (!hasRoute) {
            const token = getToken()

            if (!token) {
                history.push('/404')
                return false
            }

            history.push('/')
            return false
        }

        return true
    }

    // 双奇应用路由
    const isSqmall = window.PROJECT_CONFIG.terminalNameSecond === PROJECT_CONFIG.sqmallTerminalName

    if (isSqmall) {
        const hasRoute = getCurrentRoute({
            router: window.PROJECT_CONFIG.routes,
            pathname: location?.pathname
        })

        if (!hasRoute) {
            const token = getToken()

            if (!token) {
                history.push('/404')
                return false
            }

            onSqGoChannel({ pathname: `${location?.pathname}${location?.search}`, isOpen: true })

            const isNoInSqTowerPage = noInSqTowerPageList.find(v => pathRegexp(v).exec(location?.pathname))

            if (isNoInSqTowerPage) {
                window.history.go(-1)
            }

            return false
        }

        return true
    }

    // 双奇塔内路由
    const isSqmallTower =
        window.PROJECT_CONFIG.terminalNameSecond === PROJECT_CONFIG.towerTerminalName && window.TERMINANAME_IS_SQMALL

    if (isSqmallTower) {
        const hasRoute = sqTowerPageList.find(v => pathRegexp(v).exec(location?.pathname))

        if (!hasRoute) {
            return false
        }
        return true
    }

    return true
}

/**
 * tab => 寻合作 => 独立站 => 特殊应用处理
 */
export default () => {
    // 是否需要拦截寻合作域名
    const isNeedBlockFindFoopDomain = checkShouldBlock()
    if (isNeedBlockFindFoopDomain) {
        blockFindCoop(history.location, true)

        history.block((location, action) => {
            // 路由还原
            restoreTabHistoryLoaction(location, action)

            // 寻合作域名重定向
            const res = blockFindCoop(location)

            // 新开窗口的情况下为false，阻止路由变更
            if (!res) {
                return false
            }

            // 分销小站页面重定向
            const dlzId = readDlzParamsId(location)

            if (dlzId) {
                return loadPartnerShopConfig({
                    location,
                    dlzId
                }).then(e => openPatnerShop(e, () => true))
            }

            const specialRes = blockSpecialAppLocation(location)

            if (!specialRes) {
                return false
            }

            return true
        })
    } else {
        history.block((location, action) => {
            // 路由还原
            restoreTabHistoryLoaction(location, action)

            // 分销小站页面重定向
            const dlzId = readDlzParamsId(location)

            if (dlzId) {
                return loadPartnerShopConfig({
                    location,
                    dlzId
                }).then(e => openPatnerShop(e, () => true))
            }

            const specialRes = blockSpecialAppLocation(location)

            if (!specialRes) {
                return false
            }

            return true
        })
    }
}
